import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { UnitsEffects } from './effects/units.effects';
import { UnitGroupsEffects } from './effects/unit-groups.effects';
import { PositionsEffects } from './effects/positions.effects';
import { UnitAllDataEffects } from './effects/unit-all-data.effects';
import { ControlledInputsEffects } from './effects/controlled-inputs.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('unit', reducers),
    EffectsModule.forFeature([
      UnitsEffects,
      UnitGroupsEffects,
      PositionsEffects,
      UnitAllDataEffects,
      ControlledInputsEffects,
    ]),
  ]
})
export class UnitsStoreModule {}
